/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _smoothScrollTo = _interopRequireDefault(require("../../packages/smoothScrollTo"));
var _default = function _default(node, _ref) {
  var orientation = _ref.orientation,
    direction = _ref.direction,
    pageSize = _ref.pageSize,
    duration = _ref.duration;
  if (!direction) {
    throw new Error('Please provide a scroll direction: 1 or -1!');
  }
  var horiz = orientation == 'horizontal';
  var scrollPosName = horiz ? 'scrollLeft' : 'scrollTop';
  pageSize = pageSize || (horiz ? node.clientWidth - 20 : node.clientHeight - 20);
  var currentValue = node[scrollPosName];
  var newValue = currentValue + direction * pageSize;
  (0, _smoothScrollTo.default)(node, newValue, {
    orientation: orientation,
    duration: duration
  });
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/scrollPage/index.js
// module id = 770
// module chunks = 0